var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Flatlist = _interopRequireDefault(require("../../Web/Flatlist"));

var _LoadingSpinner = _interopRequireDefault(require("../Basic/LoadingSpinner"));

var _Basic = require("../../../elements/Basic");

var _Commentary = _interopRequireDefault(require("./Commentary"));

var _NoData = _interopRequireDefault(require("../Basic/DataFetching/NoData"));

var _PropsHelper = require("../../../utilities/PropsHelper");

var _VisibilitySensor = _interopRequireDefault(require("../../Web/VisibilitySensor"));

var _RefreshButton = _interopRequireDefault(require("../RefreshButton"));

var _helper = require("./helper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/ConferenceTicker/index.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var ConferenceTicker = function (_React$Component) {
  (0, _inherits2.default)(ConferenceTicker, _React$Component);

  var _super = _createSuper(ConferenceTicker);

  function ConferenceTicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ConferenceTicker);
    _this = _super.call(this, props);

    _this.handleScroll = function () {
      var isMobile = _this.props.isMobile;
      var scrollUp = _this.oldY > window.scrollY;
      _this.oldY = window.scrollY;

      if (_this.refreshButton) {
        if (!isMobile && _this.visibilitySensor) {
          if (scrollUp) {
            _this.refreshButton.setDisplayState(false);

            _this.refreshButton.setPositionState(!_this.visibilitySensor.isVisible);
          } else if (_this.refreshButtonEnabled) {
            _this.refreshButton.setDisplayState(true);

            if (!isMobile && !_this.refreshButton.state.fixed) {
              _this.refreshButton.setPositionState(!_this.visibilitySensor.isVisible);
            }
          }
        } else {
          _this.refreshButton.setPositionState(_this.hasPageEndReached());
        }
      }
    };

    _this.hasLiveMatch = function (matches) {
      return matches && matches.some(function (match) {
        return match.isLive;
      });
    };

    _this.hasPageEndReached = function () {
      if (_this.refreshButtonNode && typeof _this.refreshButtonNode.getBoundingClientRect === 'function') {
        var _this$refreshButtonNo = _this.refreshButtonNode.getBoundingClientRect(),
            top = _this$refreshButtonNo.top;

        return top !== 0 && top <= (_this.props.isMobile ? 10 : 55);
      }

      return false;
    };

    _this.handleRefreshButtonPosition = function () {
      if (_this.hasPageEndReached()) {
        _this.refreshButton.setPositionState(_this.props.isMobile);
      }
    };

    _this.enableRefreshButton = function (enabled) {
      _this.refreshButtonEnabled = enabled;
    };

    _this.visibilityStateChanged = function (isVisible) {
      if (!_this.props.isMobile && _this.refreshButton && !_this.hasPageEndReached()) {
        _this.refreshButton.setPositionState(!isVisible);
      }
    };

    _this.refreshButtonEnabled = false;
    return _this;
  }

  (0, _createClass2.default)(ConferenceTicker, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          commentaries = _this$props.commentaries,
          header = _this$props.header,
          isFetching = _this$props.isFetching,
          isLoading = _this$props.isLoading,
          onEndReached = _this$props.onEndReached,
          endReached = _this$props.endReached,
          commentaryBackground = _this$props.commentaryBackground,
          eventStyles = _this$props.eventStyles,
          eventListStyles = _this$props.eventListStyles,
          matchComponent = _this$props.matchComponent,
          commentaryComponent = _this$props.commentaryComponent,
          renderRightColumn = _this$props.renderRightColumn,
          isMobile = _this$props.isMobile,
          store = _this$props.store,
          matches = _this$props.matches,
          onRefreshButtonPress = _this$props.onRefreshButtonPress,
          status = _this$props.status,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["commentaries", "header", "isFetching", "isLoading", "onEndReached", "endReached", "commentaryBackground", "eventStyles", "eventListStyles", "matchComponent", "commentaryComponent", "renderRightColumn", "isMobile", "store", "matches", "onRefreshButtonPress", "status"]);

      var button = _react.default.createElement(_react.default.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 133,
          columnNumber: 13
        }
      }, _react.default.createElement(_RefreshButton.default, (0, _extends2.default)({
        innerRef: function innerRef(ref) {
          _this2.refreshButton = ref;
          _this2.refreshButtonNode = _reactDom.default.findDOMNode(ref);
        },
        onPress: function onPress() {
          _this2.refreshButtonEnabled = false;
          onRefreshButtonPress();
        },
        handleRefreshButtonPosition: this.handleRefreshButtonPosition,
        enableRefreshButton: this.enableRefreshButton,
        isLive: this.hasLiveMatch(matches),
        withoutStickyHeader: true,
        refreshParameters: {
          matches: matches
        }
      }, {
        store: store,
        isMobile: isMobile
      }, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 134,
          columnNumber: 17
        }
      })), !isMobile && this.refreshButtonNode && typeof this.refreshButtonNode.getBoundingClientRect === 'function' ? _react.default.createElement(_VisibilitySensor.default, {
        ref: function ref(_ref) {
          _this2.visibilitySensor = _ref;
        },
        onChange: this.visibilityStateChanged,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 164,
          columnNumber: 21
        }
      }) : null);

      return _react.default.createElement(_Basic.Column, (0, _extends2.default)({}, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 177,
          columnNumber: 13
        }
      }), header, _react.default.createElement(_Basic.Row, (0, _extends2.default)({
        justifyContent: "space-between"
      }, eventListStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 179,
          columnNumber: 17
        }
      }), _react.default.createElement(_Basic.Column, {
        flexing: true,
        position: "relative",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 180,
          columnNumber: 21
        }
      }, isMobile ? button : null, _react.default.createElement(_Flatlist.default, {
        scrollEventThrottle: 160,
        ListFooterComponent: (0, _PropsHelper.getValueConditionally)(!endReached, _react.default.createElement(_LoadingSpinner.default, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 186,
            columnNumber: 33
          }
        })),
        ListEmptyComponent: _react.default.createElement(_Basic.Row, {
          center: true,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 189,
            columnNumber: 33
          }
        }, (isFetching || isLoading) && (0, _isEmpty.default)(commentaries) ? _react.default.createElement(_LoadingSpinner.default, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 191,
            columnNumber: 41
          }
        }) : _react.default.createElement(_NoData.default, {
          messageValue: (0, _helper.buildMessage)(matches, header, commentaries, status),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 193,
            columnNumber: 41
          }
        })),
        removeClippedSubviews: true,
        webContentContainerStyles: {
          paddingTop: 8,
          width: '100%',
          minWidth: 0
        },
        initialNumToRender: 20,
        data: commentaries,
        keyExtractor: function keyExtractor(item, index) {
          return item + index;
        },
        renderItem: function renderItem(_ref2) {
          var item = _ref2.item,
              index = _ref2.index;
          var type = item.type;
          var match = item.match ? _objectSpread(_objectSpread({}, item.match), {}, {
            homeScore: (0, _get.default)(item, 'commentary.scoreHome'),
            awayScore: (0, _get.default)(item, 'commentary.scoreAway')
          }) : undefined;

          switch (type) {
            case 'AD':
              return null;

            default:
              return typeof commentaryComponent === 'function' ? commentaryComponent(index, item.commentary, match) : _react.default.createElement(_Commentary.default, {
                matchComponent: matchComponent,
                match: match,
                commentary: item.commentary,
                mt: (0, _PropsHelper.getValueConditionally)(index === 0, 3),
                mb: 2,
                py: 2,
                eventStyles: eventStyles,
                bg: index % 2 === 0 ? commentaryBackground.even : commentaryBackground.odd,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 229,
                  columnNumber: 45
                }
              });
          }
        },
        onEndReached: onEndReached,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 182,
          columnNumber: 25
        }
      }), !isMobile ? button : null), renderRightColumn && _react.default.createElement(_Basic.View, {
        pt: 3,
        ref: function ref(_ref3) {
          _this2.rightColumRef = _reactDom.default.findDOMNode(_ref3);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 251,
          columnNumber: 25
        }
      }, renderRightColumn)));
    }
  }]);
  return ConferenceTicker;
}(_react.default.Component);

exports.default = ConferenceTicker;
ConferenceTicker.propTypes = {
  commentaries: _propTypes.default.arrayOf(_propTypes.default.object),
  header: _propTypes.default.object,
  commentaryBackground: _propTypes.default.object,
  onEndReached: _propTypes.default.func,
  eventStyles: _propTypes.default.object,
  eventListStyles: _propTypes.default.object,
  matchComponent: _propTypes.default.func,
  commentaryComponent: _propTypes.default.func,
  renderRightColumn: _propTypes.default.object,
  isMobile: _propTypes.default.bool,
  store: _propTypes.default.object,
  matches: _propTypes.default.instanceOf(Array),
  onRefreshButtonPress: _propTypes.default.func
};
ConferenceTicker.defaultProps = {
  commentaryBackground: {
    even: 'background.main',
    odd: 'background.main'
  },
  eventListStyles: {
    mx: [2, 0]
  }
};